export enum COOKIE_NAME {
  SESSION_START = "o_squirrel_sessionStart",
  SESSION_START_SENDED = "o_squirrel_sessionStart_sended"
}
